import * as React from 'react';
import { Box, Grid, Button, TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Snackbar, Alert, Tooltip, Chip } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FormHelperText from '@mui/material/FormHelperText';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Modal from '@mui/material/Modal';
import InfoIcon from '@mui/icons-material/Info';
import { ProfileDetails } from '../ProfileDetails';

import CheckIcon from '@mui/icons-material/Check';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const projStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '80%',
    'overflow-y': 'scroll',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

export const LeadDetailsComp = (props) => {

    const formatINNumber = (amount) => {
        return amount.toLocaleString('en-IN');
    }


    return (
        <Box>
            <Box className="form-head" sx={{ position: 'fixed', top: 64, zIndex: 9, display: 'none', backgroundColor: '#ffffff' }}>
                <Grid container>
                    <Grid md={12} textAlign={'end'}>
                        <Box>
                            {
                                props.mystate.mode === 'edit' ?
                                    props.LeadFormData.ddlLeadStatus !== 'Converted To Booking' ?
                                        <Button className='grey-theme-btn' variant="outlined" startIcon={<CheckIcon />} onClick={() => props.NavigateTo('booking/lead-' + props.LeadFormData.txtLeadId)}>
                                            Convert To Booking
                                        </Button>
                                        :
                                        <Box>
                                            <Typography><Chip sx={{ backgroundColor: '#042740 ', color: '#fff' }} label={'Booked Date : ' + props.mystate.leadDetails[0].bookingDate} /></Typography>
                                        </Box>
                                    :
                                    null
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Box>



            <Box style={{ marginTop: '20px' }}>

                <Grid container>
                    <Grid md={12} id="customer">
                        <Box p={1}>
                            <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                Candidate Details
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid xs={12} md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtCandidateName" name='txtCandidateName' error={props.LeadFormData.txtCandidateNameErr == undefined || props.LeadFormData.txtCandidateNameErr == '' ? false : true} helperText={props.LeadFormData.txtCandidateNameErr} onChange={(e) => props.HandleInputs(e, 'txtCandidateName')} value={props.LeadFormData.txtCandidateName || ''} label="Full Name*" variant="outlined" />
                        </Box>
                    </Grid>

                    {
                       props.mystate.mode === 'edit'&& props.mystate.userData.profile === 'Marketing' ?
                            null
                            :
                            <Grid xs={12} md={3}>
                                <Box p={1}>
                                    <TextField disabled={props.mystate.mode === 'edit' ? true : false} className="text-input" id="txtMobileNumber" name='txtMobileNumber' error={props.LeadFormData.txtMobileNumberErr == undefined || props.LeadFormData.txtMobileNumberErr == '' ? false : true} helperText={props.LeadFormData.txtMobileNumberErr} onChange={(e) => props.HandleInputs(e, 'txtMobileNumber')} value={props.LeadFormData.txtMobileNumber || ''} label="Mobile Number*" inputProps={{ maxLength: 10 }} variant="outlined" />
                                </Box>
                            </Grid>
                    }


                    {/* <Grid md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtAlternateMobileNumber" name='txtAlternateMobileNumber' error={props.LeadFormData.txtAlternateMobileNumberErr == undefined || props.LeadFormData.txtAlternateMobileNumberErr == '' ? false : true} helperText={props.LeadFormData.txtAlternateMobileNumberErr} onChange={(e) => props.HandleInputs(e, 'txtAlternateMobileNumber')} value={props.LeadFormData.txtAlternateMobileNumber || ''} inputProps={{ maxLength: 10 }} label="Alternative Mobile Number" variant="outlined" />
                        </Box>
                    </Grid> */}

                    <Grid xs={12} md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtEmailId" name='txtEmailId' error={props.LeadFormData.txtEmailIdErr == undefined || props.LeadFormData.txtEmailIdErr == '' ? false : true} helperText={props.LeadFormData.txtEmailIdErr} onChange={(e) => props.HandleInputs(e, 'txtEmailId')} value={props.LeadFormData.txtEmailId || ''} label="Email*" variant="outlined" />
                        </Box>
                    </Grid>

                    {/* <Grid md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtLeadPincode" name='txtLeadPincode' error={props.LeadFormData.txtLeadPincodeErr == undefined || props.LeadFormData.txtLeadPincodeErr == '' ? false : true} helperText={props.LeadFormData.txtLeadPincodeErr} onChange={(e) => props.HandleInputs(e, 'txtLeadPincode')} value={props.LeadFormData.txtLeadPincode || ''} label="Pincode*" inputProps={{ maxLength: 6 }} variant="outlined" />
                        </Box>
                    </Grid> */}


                    {/* <Grid md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtGraduation" name='txtGraduation' error={props.LeadFormData.txtGraduationErr == undefined || props.LeadFormData.txtGraduationErr == '' ? false : true} helperText={props.LeadFormData.txtGraduationErr} onChange={(e) => props.HandleInputs(e, 'txtGraduation')} value={props.LeadFormData.txtGraduation || ''} label="Graduation*" variant="outlined" />
                        </Box>
                    </Grid> */}
                    {/* 
                    <Grid md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtPostGraduation" name='txtPostGraduation' error={props.LeadFormData.txtPostGraduationErr == undefined || props.LeadFormData.txtPostGraduationErr == '' ? false : true} helperText={props.LeadFormData.txtPostGraduationErr} onChange={(e) => props.HandleInputs(e, 'txtPostGraduation')} value={props.LeadFormData.txtPostGraduation || ''} label="Post Graduation*" variant="outlined" />
                        </Box>
                    </Grid> */}

                    <Grid md={3}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlLeadState || ''}
                                    label="State"
                                    error={props.LeadFormData.ddlLeadStateErr == undefined || props.LeadFormData.ddlLeadStateErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlLeadState')}
                                >
                                    {
                                        props.mystate.stateListData.length > 0 ?

                                            props.mystate.stateListData.map((item) =>
                                                <MenuItem value={item}>{item}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadStateErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid md={3}>
                        <Box p={1}>
                            <FormControl fullWidth>

                                <TextField
                                    select
                                    value={props.LeadFormData.ddlLeadDistrict || ''}
                                    label="District"
                                    error={props.LeadFormData.ddlLeadDistrictErr == undefined || props.LeadFormData.ddlLeadDistrictErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlLeadDistrict')}
                                >
                                    {
                                        props.cityListData.length > 0 ?

                                            props.cityListData.map((element) =>
                                                <MenuItem value={element}>{element}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadDistrictErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                     <Grid xs={12} md={3}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlCandidateGender || ''}
                                    label="Gender"
                                    error={props.LeadFormData.ddlCandidateGenderErr == undefined || props.LeadFormData.ddlCandidateGenderErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlCandidateGender')}
                                >

                                    <MenuItem value={'Male'}>{'Male'}</MenuItem>
                                    <MenuItem value={'Female'}>{'Female'}</MenuItem>
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlCandidateGenderErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    
                    <Grid md={3}>
                        <Box p={1}>
                            <TextField className="text-input" id="txtCandidateAge" name='txtCandidateAge' error={props.LeadFormData.txtCandidateAgeErr == undefined || props.LeadFormData.txtCandidateAgeErr == '' ? false : true} helperText={props.LeadFormData.txtCandidateAgeErr} onChange={(e) => props.HandleInputs(e, 'txtCandidateAge')} value={props.LeadFormData.txtCandidateAge || ''} label="Age" variant="outlined" />
                        </Box>
                    </Grid>


                    <Grid xs={12} md={3}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlCandidateExp || ''}
                                    label="Work Experience"
                                    error={props.LeadFormData.ddlCandidateExpErr == undefined || props.LeadFormData.ddlCandidateExpErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlCandidateExp')}
                                >

                                    <MenuItem value={'0'}>{'Fresher'}</MenuItem>
                                    <MenuItem value={'1'}>{'1'}</MenuItem>
                                    <MenuItem value={'2'}>{'2'}</MenuItem>
                                    <MenuItem value={'3'}>{'3'}</MenuItem>
                                    <MenuItem value={'4'}>{'4'}</MenuItem>
                                    <MenuItem value={'5'}>{'5'}</MenuItem>
                                    <MenuItem value={'6'}>{'6'}</MenuItem>
                                    <MenuItem value={'7'}>{'7'}</MenuItem>
                                    <MenuItem value={'8'}>{'8'}</MenuItem>
                                    <MenuItem value={'9'}>{'9'}</MenuItem>
                                    <MenuItem value={'10'}>{'10'}</MenuItem>
                                    <MenuItem value={'11'}>{'11'}</MenuItem>
                                    <MenuItem value={'12'}>{'12'}</MenuItem>
                                    <MenuItem value={'13'}>{'13'}</MenuItem>
                                    <MenuItem value={'14'}>{'14'}</MenuItem>
                                    <MenuItem value={'15'}>{'15'}</MenuItem>
                                    <MenuItem value={'16'}>{'16'}</MenuItem>
                                    <MenuItem value={'17'}>{'17'}</MenuItem>
                                    <MenuItem value={'18'}>{'18'}</MenuItem>
                                    <MenuItem value={'19'}>{'19'}</MenuItem>
                                    <MenuItem value={'20'}>{'20'}</MenuItem>
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlCandidateGenderErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    <Grid xs={12} md={3}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlCandidateQual || ''}
                                    label="Qualification"
                                    error={props.LeadFormData.ddlCandidateQualErr == undefined || props.LeadFormData.ddlCandidateQualErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlCandidateQual')}
                                >
                                    <MenuItem value={'Final year gnm'}>{'Final year gnm'}</MenuItem>
                                    <MenuItem value={'Final year bsc nursing'}>{'Final year bsc nursing'}</MenuItem>
                                    <MenuItem value={'Gnm'}>{'Gnm'}</MenuItem>
                                    <MenuItem value={'Bcs nursing'}>{'Bcs nursing'}</MenuItem>
                                    <MenuItem value={'MSc nursing'}>{'MSc nursing'}</MenuItem>
                                    <MenuItem value={'Other'}>{'Other'}</MenuItem>
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlCandidateQualErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                      <Grid xs={12} md={3}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlCandidateBatchTime || ''}
                                    label="Preferred Batch Time"
                                    error={props.LeadFormData.ddlCandidateBatchTimeErr == undefined || props.LeadFormData.ddlCandidateBatchTimeErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlCandidateBatchTime')}
                                >
                                    <MenuItem value={'09 AM - 11 AM'}>{'09 AM - 11 AM'}</MenuItem>
                                    <MenuItem value={'11 AM - 01 PM'}>{'11 AM - 01 PM'}</MenuItem>
                                    <MenuItem value={'01 PM - 03 PM'}>{'01 PM - 03 PM'}</MenuItem>
                                    <MenuItem value={'03 PM - 05 PM'}>{'03 PM - 05 PM'}</MenuItem>
                                    <MenuItem value={'05 PM - 07 PM'}>{'05 PM - 07 PM'}</MenuItem>
                                    <MenuItem value={'07 PM - 09 PM'}>{'07 PM - 09 PM'}</MenuItem>
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlCandidateBatchTimeErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>


                </Grid>

                <Grid container>
                    <Grid xs={12} md={12} mt={5} id="acquisition">
                        <Box p={1}>
                            <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                Lead Acquisition Details
                            </Typography>
                        </Box>
                    </Grid>


                    <Grid xs={12} md={4}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlLeadSource || ''}
                                    label="Select Source*"
                                    error={props.LeadFormData.ddlLeadSourceErr == undefined || props.LeadFormData.ddlLeadSourceErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlLeadSource')}
                                >

                                    {
                                        props.mystate.sourceListData.length > 0 ?
                                            props.mystate.sourceListData.map((item) =>
                                                <MenuItem value={item}>{item}</MenuItem>
                                            )
                                            :
                                            null
                                    }
                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadSourceErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>



                </Grid>


                <Grid container>
                    <Grid xs={12} md={12} mt={5} id="allocation">
                        <Box p={1}>
                            <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                Lead Allocation Details
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid xs={12} md={4}>
                        <Box p={1}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    value={props.LeadFormData.ddlLeadStatus || ''}
                                    label="Select Status*"
                                    error={props.LeadFormData.ddlLeadStatusErr == undefined || props.LeadFormData.ddlLeadStatusErr == '' ? false : true}
                                    onChange={(e) => props.HandleInputs(e, 'ddlLeadStatus')}
                                >
                                    {
                                        props.mystate.userData.allowedStages.map((item, i) =>
                                            <MenuItem key={i} value={item}>{item}</MenuItem>
                                        )
                                    }


                                </TextField>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadStatusErr}</FormHelperText>
                            </FormControl>
                        </Box>
                    </Grid>

                    {
                        props.mystate.userData.profile === 'Sales' ?
                            null
                            :
                            <Grid xs={12} md={4}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            label={'Select Department*'}
                                            value={props.LeadFormData.ddlLeadDepartment || ''}
                                            error={props.LeadFormData.ddlLeadDepartmentErr == undefined || props.LeadFormData.ddlLeadDepartmentErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlLeadDepartment')}
                                        >
                                            {
                                                props.mystate.profileListData.length > 0 ?
                                                    props.mystate.profileListData.map((item) =>
                                                        props.mystate.userData.profile === 'Sales TL' ?
                                                            item.profile_name === 'Sales' ?
                                                                <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                                                :
                                                                null
                                                            :
                                                            props.mystate.userData.profile === 'Telecaller' ?
                                                                item.profile_name.includes('Sales') || item.profile_name.includes('Tele') ?
                                                                    <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>
                                                                    :
                                                                    null
                                                                :
                                                                <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>

                                                    )
                                                    :
                                                    null
                                            }
                                        </TextField>
                                        <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadDepartmentErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>
                    }



                    {
                        props.mystate.userData.profile === 'Sales' ?
                            null
                            :

                            <Grid xs={12} md={4}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            value={props.LeadFormData.ddlLeadOwner || ''}
                                            label="Select Owner*"
                                            error={props.LeadFormData.ddlLeadOwnerErr == undefined || props.LeadFormData.ddlLeadOwnerErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlLeadOwner')}
                                        >
                                            {
                                                props.mystate.userListData.length > 0 ?

                                                    props.mystate.userListData.map((item) =>
                                                        item.user_profile_name === props.LeadFormData.ddlLeadDepartment ?
                                                            <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                        </TextField>
                                        <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadOwnerErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>

                    }


                </Grid>

                {

                    props.LeadFormData.ddlLeadStatus === 'Interview Scheduled' || (props.LeadFormData.ddlInterviewerName !== undefined && props.LeadFormData.ddlInterviewerName !== '') ?
                        <Grid container>
                            <Grid xs={12} md={12} mt={5} id="allocation">
                                <Box p={1}>
                                    <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                        Interview Details
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            value={props.LeadFormData.ddlInterviewerName || ''}
                                            label="Select Interviewer*"
                                            error={props.LeadFormData.ddlInterviewerNameErr == undefined || props.LeadFormData.ddlInterviewerNameErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlInterviewerName')}
                                        >
                                            {
                                                props.mystate.userListData.length > 0 ?

                                                    props.mystate.userListData.map((item) =>
                                                        item.user_profile_name === 'German Teacher' ?
                                                            <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                            :
                                                            null
                                                    )
                                                    :
                                                    null
                                            }
                                        </TextField>
                                        <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlInterviewerNameErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid xs={12} md={4}>
                                <Box pl={1} pr={1}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtInterviewDate')} label="Interview Date*" value={dayjs(props.LeadFormData.txtInterviewDate != undefined ? props.LeadFormData.txtInterviewDate : '')} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                        </Grid>
                        :
                        null
                }


                {

                    props.LeadFormData.ddlLeadStatus === 'Joined' ?
                        <Grid container>
                            <Grid xs={12} md={12} mt={5} id="allocation">
                                <Box p={1}>
                                    <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                        On Boarding Details
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <Box pl={1} pr={1}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DatePicker']}>
                                            <DatePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtJoiningDate')} label="Joining Date*" value={dayjs(props.LeadFormData.txtJoiningDate != undefined ? props.LeadFormData.txtJoiningDate : '')} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            <Grid xs={12} md={4}>
                                <Box p={1}>
                                    <FormControl fullWidth>
                                        <TextField
                                            select
                                            value={props.LeadFormData.ddlClassMode || ''}
                                            label="Select Class Mode*"
                                            error={props.LeadFormData.ddlClassModeErr == undefined || props.LeadFormData.ddlClassModeErr == '' ? false : true}
                                            onChange={(e) => props.HandleInputs(e, 'ddlClassMode')}
                                        >
                                            <MenuItem value={'Online'}>{'Online'}</MenuItem>
                                            <MenuItem value={'Offline'}>{'Offline'}</MenuItem>
                                            <MenuItem value={'Hybrid'}>{'Hybrid'}</MenuItem>
                                        </TextField>
                                        <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlClassModeErr}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Grid>
                        </Grid>
                        :
                        null
                }


                <Grid container>
                    <Grid xs={12} md={12} mt={5} id="description">
                        <Box p={1}>
                            <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                Description
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid xs={12} md={6}>
                        <Box p={1}>
                            <TextField multiline rows={4} className="text-input" id="txtLeadDesc" name='txtLeadDesc' error={props.LeadFormData.txtLeadDescErr == undefined || props.LeadFormData.txtLeadDescErr == '' ? false : true} helperText={props.LeadFormData.txtLeadDescErr} onChange={(e) => props.HandleInputs(e, 'txtLeadDesc')} value={props.LeadFormData.txtLeadDesc || ''} label="Enter Your Note" variant="outlined" />
                        </Box>
                    </Grid>



                </Grid>


                {
                    props.mystate.mode === 'edit' ?
                        <Grid container>
                            <Grid xs={6} md={6} mt={5} id="description">
                                <Box p={1}>
                                    <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                        Comments
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid xs={6} md={6} mt={5}>
                                {
                                    props.mystate.userData.profile !== 'Marketing' ?
                                        <Box p={1} textAlign={'right'}>
                                            <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleDescriptionBox()}>Add New</Button>
                                        </Box>
                                        :
                                        null
                                }
                            </Grid>

                            <Grid xs={12} md={12}>
                                <Box p={1}>
                                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                        <TableContainer sx={{ maxHeight: '200px' }}>
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            key={'SrNo'}
                                                            align={'left'}
                                                            width={50}
                                                            className='table-head-cell'
                                                        >
                                                            {'SrNo'}
                                                        </TableCell>
                                                        <TableCell
                                                            key={'Added On'}
                                                            align={'left'}
                                                            width={100}
                                                            className='table-head-cell'
                                                        >
                                                            {'Added On'}
                                                        </TableCell>
                                                        <TableCell
                                                            key={'Added By'}
                                                            align={'left'}
                                                            width={100}
                                                            className='table-head-cell'
                                                        >
                                                            {'Added By'}
                                                        </TableCell>
                                                        <TableCell
                                                            key={'Comment'}
                                                            align={'left'}
                                                            width={150}
                                                            className='table-head-cell'
                                                        >
                                                            {'Comment'}
                                                        </TableCell>



                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.mystate.leadDetails != undefined && props.mystate.leadDetails.length > 0 && props.mystate.leadDetails[0].comment_array.length > 0 ?
                                                        props.mystate.leadDetails[0].comment_array.map((item, i) => (
                                                            <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                                                <TableCell key={i + 1} align={'left'}>
                                                                    {i + 1}
                                                                </TableCell>
                                                                <TableCell key={item.Date + i} align={'left'}>
                                                                    {item.Date}
                                                                </TableCell>
                                                                <TableCell key={item["Added By"] + i} align={'left'}>
                                                                    {item["Added By"]} <br></br> <strong>{item["Added By Profile"]}</strong>
                                                                </TableCell>
                                                                <TableCell key={item.Comment + i} align={'left'}>
                                                                    <span>{item.Comment}</span>
                                                                </TableCell>

                                                            </TableRow>
                                                        ))
                                                        : ''
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            </Grid>
                        </Grid>
                        :
                        null
                }




                <Grid container>
                    <Grid xs={12} md={12}>
                        <Box m={2} textAlign={'center'}>
                            {
                                props.mystate.mode == 'add' ?

                                    props.LeadFormData.addUser == true ?

                                        <LoadingButton
                                            loading
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                            variant="outlined"
                                            className='grey-theme-btn'
                                        >
                                            Add New Lead
                                        </LoadingButton>
                                        :

                                        <Button className='grey-theme-btn' variant="outlined" onClick={() => props.SaveOrUpdateLead()}>Add New Lead</Button>
                                    :
                                    props.LeadFormData.editUser == true ?

                                        <LoadingButton
                                            loading
                                            loadingPosition="start"
                                            startIcon={<SaveIcon />}
                                            variant="outlined"
                                            className='grey-theme-btn'
                                        >
                                            Update Lead
                                        </LoadingButton>
                                        :
                                        props.LeadFormData.txtUserName == '' ?
                                            ''
                                            :
                                            props.LeadFormData.ddlLeadStatus !== 'Converted To Booking' && props.mystate.userData.profile !== 'Marketing' ?
                                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.SaveOrUpdateLead()}>Update Lead</Button>
                                                :
                                                null
                            }

                        </Box>
                    </Grid>

                </Grid>

            </Box>


            <Modal
                open={props.mystate.openDescriptionBox}
                onClose={() => props.ToggleDescriptionBox()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Comment
                    </Typography>
                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtLeadComment" name='txtLeadComment' error={props.LeadFormData.txtLeadCommentErr == undefined || props.LeadFormData.txtLeadCommentErr == '' ? false : true} helperText={props.LeadFormData.txtLeadCommentErr} onChange={(e) => props.HandleInputs(e, 'txtLeadComment')} value={props.LeadFormData.txtLeadComment || ''} label="Enter Your Comment" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid sx={6}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddDescription()}>Add</Button>
                            </Grid>
                            <Grid sx={6} ml={2}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleDescriptionBox()}>Cancel</Button>
                            </Grid>
                        </Grid>
                    </Box>

                </Box>
            </Modal>


        


            <Snackbar open={props.mystate.showAlert} autoHideDuration={3000} onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}>
                <Alert
                    onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>

        </Box>


    );
}